import thumbnailSlideTemplate from '../templates/single-product-page/thumbnail-slide.hbs';
import imageSlideTemplate from '../templates/single-product-page/image-slide.hbs';
import videoSlideTemplate from '../templates/single-product-page/video-slide.hbs';
import spin360SlideTemplate from '../templates/single-product-page/360-slide.hbs';

/*
 * Helper class used on product landing page
 *   renders the templates for each slide type
 */
/* eslint-disable class-methods-use-this */
export default class SingleProductHelper {
    renderThumbnailSlide(context) {
        return thumbnailSlideTemplate(context);
    }

    renderImageSlide(context) {
        return imageSlideTemplate(context);
    }

    renderVideoSlide(context) {
        return videoSlideTemplate(context);
    }

    render360Slide(context) {
        return spin360SlideTemplate(context);
    }
}
